import useBackboneContext from "../provider/useBackboneContext";
import useBaseModelChange from "./useBaseModelChange";
import { ICartData } from "@src/interface/Cart";

const useCartModelChange = (list: Array<keyof ICartData> | "change") => {
  const { app } = useBackboneContext();
  return useBaseModelChange(list, app.getCart());
};

export default useCartModelChange;
